/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pdf_Cv_Review_Overall_ScoreInputs */

const en_pdf_cv_review_overall_score = /** @type {(inputs: Pdf_Cv_Review_Overall_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overall Score`)
};

const de_pdf_cv_review_overall_score = /** @type {(inputs: Pdf_Cv_Review_Overall_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamtbewertung`)
};

/**
* | output |
* | --- |
* | "Overall Score" |
*
* @param {Pdf_Cv_Review_Overall_ScoreInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pdf_cv_review_overall_score = /** @type {((inputs?: Pdf_Cv_Review_Overall_ScoreInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pdf_Cv_Review_Overall_ScoreInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pdf_cv_review_overall_score(inputs)
	return en_pdf_cv_review_overall_score(inputs)
});